var _title, _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgDelete = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "12px",
    height: "12px",
    viewBox: "0 0 12 12",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Group")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    fill: "#C7C7C7",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.93846154,11.8769231 C9.21025641,11.8769231 11.8769231,9.21025641 11.8769231,5.93846154 C11.8769231,2.66666667 9.21025641,0 5.93846154,0 C2.66666667,0 0,2.66666667 0,5.93846154 C0,9.21025641 2.66666667,11.8769231 5.93846154,11.8769231 Z M5.93846154,0.830769231 C8.74871795,0.830769231 11.0461538,3.11794872 11.0461538,5.93846154 C11.0461538,8.75897436 8.75897436,11.0461538 5.93846154,11.0461538 C3.11794872,11.0461538 0.830769231,8.74871795 0.830769231,5.93846154 C0.830769231,3.12820513 3.12820513,0.830769231 5.93846154,0.830769231 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.26153846,6.35897436 L8.72820513,6.35897436 C8.96410256,6.35897436 9.14871795,6.17435897 9.14871795,5.93846154 C9.14871795,5.7025641 8.96410256,5.51794872 8.72820513,5.51794872 L3.26153846,5.51794872 C3.02564103,5.51794872 2.84102564,5.7025641 2.84102564,5.93846154 C2.84102564,6.17435897 3.03589744,6.35897436 3.26153846,6.35897436 Z",
    id: "Path"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDelete, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/delete.c4d86527.svg";
export { ForwardRef as ReactComponent };